module.exports = __webpack_public_path__ + "img/advertencia.d33b60eb.jpg";